import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { UiWarningIcon } from "@jti/brand-icons/ui-warning";
import { Loader } from "@jti/core-components/components/Loader";

import styles from "./ExternalAgeVerification.module.scss";

const { sanitize } = dompurify;

export type ExternalAgeVerificationProps = {
  isError?: boolean;
  isOverlay?: boolean;
  verificationTitle: string;
  verificationSteps: string;
  verificationHelperText?: string;
  verificationErrorMessage?: string;
  verificationErrorHelperText?: string;
};

export const ExternalAgeVerification: React.FC<ExternalAgeVerificationProps> = ({
  isError,
  isOverlay,
  verificationSteps,
  verificationTitle,
  verificationHelperText,
  verificationErrorMessage,
  verificationErrorHelperText,
}) => {
  const verificationMainContent = isError ? verificationErrorMessage : verificationSteps;
  const helperText = isError ? verificationErrorHelperText : verificationHelperText;

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapperOverlay]: isOverlay,
      })}
      data-testid="externalAgeVerificationWrapper"
    >
      <h3 className={styles.title}>{verificationTitle}</h3>
      <div className={styles.contentWrapper}>
        {verificationMainContent && (
          <div
            className={styles.steps}
            dangerouslySetInnerHTML={{
              __html: sanitize(verificationMainContent),
            }}
          />
        )}
        {isError ? (
          <UiWarningIcon data-testid="errorIcon" className={styles.errorIcon} />
        ) : (
          <Loader data-testid="loaderIcon" size="lg" />
        )}
        {helperText && <p className={styles.helperText}>{helperText}</p>}
      </div>
    </div>
  );
};
